import type { CatalogCategorySlug } from '@/routes/routeRegistry';

export const contentQueryKeys = {
  organizationContent: ['content', 'organization'] as const,
  adminOrganizationContent: ['content', 'admin', 'organization'] as const,
  historyEntries: ['content', 'history-entries'] as const,
  adminHistoryEntries: ['content', 'admin', 'history-entries'] as const,
  adminHistoryEntry: (historyEntryId: number) =>
    ['content', 'admin', 'history-entries', historyEntryId] as const,
  certificationAssets: ['content', 'certification-assets'] as const,
  adminCertificationAssets: ['content', 'admin', 'certification-assets'] as const,
  adminCertificationAsset: (certificationAssetId: number) =>
    ['content', 'admin', 'certification-assets', certificationAssetId] as const,
  catalogItems: (category: CatalogCategorySlug) => ['content', 'catalog-items', category] as const,
  catalogCategories: ['content', 'catalog-categories'] as const,
  adminCatalogCategories: ['content', 'admin', 'catalog-categories'] as const,
  catalogItem: (slug: string) => ['content', 'catalog-items', slug] as const,
  adminCatalogItems: (category?: CatalogCategorySlug) =>
    ['content', 'admin', 'catalog-items', category ?? 'all'] as const,
  adminCatalogItem: (catalogItemId: number) =>
    ['content', 'admin', 'catalog-items', catalogItemId] as const,
};
